import { getList, getOne, getRanking, getResults } from './getData'
import {
  setCreate,
  setUpdate,
  setDelete,
  setCreateX,
  setUpdateX,
  syncScore
} from './setData'

const pendingAspects = JSON.parse(localStorage.getItem('pendingAspects')) || {}
const pendingFaults = JSON.parse(localStorage.getItem('pendingFaults')) || {}

const refreshIsScoreSync = state => {
  state.isScoreSync =
    (!state.pendingAspects[state.scoreId] ||
      !state.pendingAspects[state.scoreId]) &&
    (!state.pendingFaults[state.scoreId] || !state.pendingFaults[state.scoreId])
}

const match = {
  namespaced: true,
  state: {
    list: [],
    loading: false,
    listSelect: [],
    idSelected: '',
    matchSelected: {},
    ranking: [],
    results: [],
    scoreId: '',
    score: {},
    pendingAspects,
    pendingFaults,
    isScoreSync: true
  },
  getters: {
    currentPendingAspects: state => state.pendingAspects[state.scoreId],
    currentPendingFaults: state => state.pendingFaults[state.scoreId],
    isScoreSync: state => {
      return (
        (!state.pendingAspects[state.scoreId] ||
          !state.pendingAspects[state.scoreId]) &&
        (!state.pendingFaults[state.scoreId] ||
          !state.pendingFaults[state.scoreId])
      )
    }
  },
  mutations: {
    updateList: (state, list) => {
      state.list = !list
        ? []
        : list.map(match => ({
            ...match,
            video: match.video
              ? process.env.VUE_APP_VIDEO_URL + match.video
              : ''
          }))
    },
    updateOneToList: (state, match) => {
      if (match) {
        const searchList = state.list.find(item => item._id === match._id)
        if (!searchList) {
          state.list.push(match)
        }
      }
    },
    updateOne: (state, one) => {
      if (one.video) one.video = process.env.VUE_APP_VIDEO_URL + one.video
      state.matchSelected = one
      state.idSelected = one._id
    },
    updateLoading: (state, loading) => (state.loading = loading),
    updateClearOne: state => {
      state.matchSelected = {}
      state.idSelected = ''
    },
    updateRanking: (state, ranking) => {
      state.ranking = ranking || []
    },
    updateResults: (state, results) => {
      state.results = results || []
    },
    setScoreId(state, scoreId) {
      state.scoreId = scoreId
      refreshIsScoreSync(state)
    },
    setScore(state, score) {
      state.score = score
    },
    setPendingAspects: (state, score) => {
      if (state.pendingAspects[state.scoreId]) {
        state.pendingAspects[state.scoreId] = [
          ...state.pendingAspects[state.scoreId].filter(
            item =>
              item.aspectRelId != score.aspectRelId ||
              item.judgeId != score.judgeId ||
              item.objectId != score.objectId
          ),
          score
        ]
      } else {
        state.pendingAspects[state.scoreId] = [score]
      }
      localStorage.setItem(
        'pendingAspects',
        JSON.stringify(state.pendingAspects)
      )
      refreshIsScoreSync(state)
    },
    setPendingFaults: (state, fault) => {
      if (state.pendingFaults[state.scoreId]) {
        state.pendingFaults[state.scoreId] = [
          ...state.pendingFaults[state.scoreId].filter(
            item =>
              item.judgeId != fault.judgeId || item.objectId != fault.objectId
          ),
          fault
        ]
      } else {
        state.pendingFaults[state.scoreId] = [fault]
      }
      localStorage.setItem('pendingFaults', JSON.stringify(state.pendingFaults))
      refreshIsScoreSync(state)
    },

    clearPendingAspects(state, scoreId) {
      delete state.pendingAspects[scoreId]
      localStorage.setItem(
        'pendingAspects',
        JSON.stringify(state.pendingAspects)
      )
      refreshIsScoreSync(state)
    },
    clearPendingFaults(state, scoreId) {
      delete state.pendingFaults[scoreId]
      localStorage.setItem('pendingFaults', JSON.stringify(state.pendingFaults))
      refreshIsScoreSync(state)
    }
  },
  actions: {
    setPendingFaults({ commit, rootState }, payload) {
      commit('setPendingFaults', payload)
      commit('acts/updateFaults', rootState.acts.faults, { root: true })
    },
    setInit: async ({ commit }, body = { finalized: false }) =>
      getList(commit, body),
    query: async ({ commit }, params) => await getList(commit, {}, params),
    setNew: async ({ commit, dispatch, rootState }, match) => {
      const result = await setCreate(match)
      commit('updateOne', result)
      let params = {}
      if (match.tournamentView) {
        params.tournamentId = match.tournamentId
        dispatch('tournaments/setOne', match.tournamentId, { root: true })
      }
      getList(commit, params, params)
      // dispatch('acts/setInit', null, {root: true})
      return result
    },
    setUpdate: async ({ commit, dispatch, rootState }, match) => {
      const result = await setUpdate(match)
      commit('updateOne', result)
      let params = {}
      if (match.tournamentView) {
        params.tournamentId = match.tournamentId
        dispatch('tournaments/setOne', match.tournamentId, { root: true })
      }
      getList(commit, params, params)
      // dispatch('acts/setInit', null, {root: true})
    },
    setDelete: async ({ commit, rootState, dispatch }, id) => {
      await setDelete(id)
      const isTournamentView = rootState.tournaments.view
      const tournament = rootState.tournaments.selected
      let params = {}
      if (isTournamentView && tournament && tournament._id) {
        dispatch('tournaments/setOne', tournament._id, { root: true })
        params.tournamentId = tournament._id
      }
      getList(commit, params)
    },
    setOne: async ({ commit }, id) => {
      await getOne(commit, id)
    },
    setClearOne: ({ commit }) => {
      commit('updateClearOne')
    },
    setRanking: async ({ commit }, params) => {
      await getRanking(commit, params)
    },
    setResults: async ({ commit }, tournamentId) => {
      await getResults(commit, tournamentId)
    },
    setNewX: async ({ commit }, match) => {
      return await setCreateX(match)
    },
    setUpdateX: async ({ commit }, match) => {
      await setUpdateX(match)
    },
    async syncCurrentScore({ state, commit, getters }) {
      const aspects = state.pendingAspects[state.scoreId] || []
      const faults = state.pendingFaults[state.scoreId] || []
      await syncScore(state.scoreId, aspects, faults)
      commit('clearPendingAspects', state.scoreId)
      commit('clearPendingFaults', state.scoreId)
    }
  }
}

export default match
